module.exports = __webpack_public_path__ + "img/veratia-map.072e77a1.png";